import { initialPath } from "~misc/paths";

const ROTAS_RETORNO = {
  emissor: ({ clienteId }) => `${initialPath}/carteira/emissor/${clienteId}?mapeamento=sucesso&emissor=${clienteId}`,
  prospect: ({ clienteId }) => `${initialPath}/carteira/prospect/${clienteId}?mapeamento=sucesso&prospect=${clienteId}`,
  roteirizacao: ({ clienteId }) => `${initialPath}/roteirizacao/${clienteId}?mapeamento=sucesso&roteirizacao=${clienteId}`,
  recebedor: ({ clienteId }) => `${initialPath}/carteira/recebedor/${clienteId}?mapeamento=sucesso&recebedor=${clienteId}`,
};

export const getReturnRoute = ({ retorno, clienteId }) => {
  return ROTAS_RETORNO[retorno]?.({ clienteId }) ?? null;
};